import { ActivatedRouteSnapshot } from '@angular/router';
import { ReuseTabContextComponent } from './reuse-tab-context.component';

/**
 * å¤ç¨å¹éæ¨¡å¼
 */
export enum ReuseTabMatchMode {
    /**
     * ï¼æ¨èï¼æèå `Menu` éç½®
     *
     * å¯å¤ç¨ï¼
     * - `{ text:'Dashboard' }`
     * - `{ text:'Dashboard', reuse: true }`
     *
     * ä¸å¯å¤ç¨ï¼
     * - `{ text:'Dashboard', reuse: false }`
     */
    Menu,
    /**
     * æèå `Menu` å¼ºå¶éç½®
     *
     * å¯å¤ç¨ï¼
     * - `{ text:'Dashboard', reuse: true }`
     *
     * ä¸å¯å¤ç¨ï¼
     * - `{ text:'Dashboard' }`
     * - `{ text:'Dashboard', reuse: false }`
     */
    MenuForce,
    /**
     * å¯¹ææè·¯ç±ææï¼å¯ä»¥éå `excludes` è¿æ»¤æ é¡»å¤ç¨è·¯ç±
     */
    URL
}

export interface ReuseTitle {
    text: string;
    i18n?: string;
}

export interface ReuseTabCached {
    title: ReuseTitle;

    url: string;

    /** æ¯å¦å¯å³é­ï¼é»è®¤ï¼`true` */
    closable?: boolean;

    _snapshot: ActivatedRouteSnapshot;

    _handle: any;
}

export interface ReuseTabNotify {
    /** äºä»¶ç±»å */
    active: string;

    [key: string]: any;
}

export interface ReuseItem {
    url: string;
    title: string;
    closable: boolean;
    index: number;
    active: boolean;
    last: boolean;
}

export interface ReuseContextEvent {
    event: MouseEvent;
    item: ReuseItem;
    comp?: ReuseTabContextComponent;
}

export type CloseType = 'close' | 'closeOther' | 'closeRight' | 'clear' | null;

export interface ReuseContextCloseEvent {
    type: CloseType;
    item: ReuseItem;
    includeNonCloseable: boolean;
}

export interface ReuseContextI18n {
    close?: string;
    closeOther?: string;
    closeRight?: string;
    clear?: string;
}
